import { useState, useCallback } from "react";
const useForceUpdate = () => {
  const [, updateState] = useState<any>();
  const forceUpdate = useCallback(() => updateState({}), []);

  return forceUpdate;
};

export default useForceUpdate;
